import { PbxHttpClient } from "@/services/httpclient";

const state = {
  assistanceList: [],
  assistanceListHistory: [],
};

const getters = {
  GET_ASSISTANCE_AGENT(state) {
    return state.assistanceList;
  },

  GET_ASSISTANCE_AGENT_HISTORY(state) {
    return state.assistanceListHistory;
  },
};

const mutations = {
  GET_ASSISTANCE_AGENT(state, payload) {
    state.assistanceList = payload;
    // state.assistanceList = state.assistanceList.concat(payload);
  },

  REMOVE_ASSISTANCE_AGENT(state, payload) {
    state.assistanceList.splice(payload, 1);
  },

  GET_ASSISTANCE_AGENT_HISTORY(state, payload) {
    state.assistanceListHistory = state.assistanceListHistory.concat(payload);
  },
};

const actions = {
  async GET({ commit, state }, payload) {
    try {
      const response = await PbxHttpClient.get(
        `/assistance/assistance?page=${payload.page}&itemPerPage=${payload.itemsPerPage}`
      );
      // const itemsInState = JSON.stringify(state.assistanceList);
      // const newItems = JSON.stringify(response.data.data);
      // if (
      //     !itemsInState.includes(
      //         newItems.substring(1, newItems.length - 1)
      //     )
      // )
      commit("GET_ASSISTANCE_AGENT", response.data.data);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async GET_HISTORY({ commit, state }, payload) {
    try {
      const response = await PbxHttpClient.get(
        `/assistance/assistanceHistory?page=${payload.page}&itemPerPage=${payload.itemsPerPage}`
      );
      const itemsInState = JSON.stringify(state.assistanceListHistory);
      const newItems = JSON.stringify(response.data.data);
      if (!itemsInState.includes(newItems.substring(1, newItems.length - 1)))
        commit("GET_ASSISTANCE_AGENT_HISTORY", response.data.data);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async REMOVE_AGENT({ commit }, payload) {
    try {
      const response = await PbxHttpClient.post(
        `/assistance/logoutAdmin/${payload.agent_id}`
      );
      // console.log(response.data.data);
      commit("REMOVE_ASSISTANCE_AGENT", response.data.data);
      // commit('REMOVE_ASSISTANCE_AGENT', payload.agent_index);
      return response.data.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

// Exportar Clientes
export const assistance = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
